import { Link } from 'react-router-dom';
import { useSubscription } from '../../hooks/queries.js';

/** Days left at which the free-trial notice stops being a quiet reminder. */
const URGENT_DAYS = 14;

/**
 * A thin strip under the header while a store is on its free trial, or after its
 * plan has ended. Silent for a paid, running plan, and while the plan is loading
 * or unavailable: a notice that flickers or errors is worse than none.
 */
export function PlanBanner(): JSX.Element | null {
  const { data } = useSubscription();
  if (!data || data.state === 'ACTIVE') return null;

  const expired = data.state === 'EXPIRED';
  const urgent = expired || data.daysLeft <= URGENT_DAYS;

  return (
    <div
      role="status"
      className={
        urgent
          ? 'border-b border-rose-200 bg-rose-50 px-4 py-2 text-sm text-rose-900 sm:px-6'
          : 'border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 sm:px-6'
      }
    >
      {expired
        ? 'Your plan has ended — you cannot add products, pages or payment methods.'
        : `Free trial: ${data.daysLeft} ${data.daysLeft === 1 ? 'day' : 'days'} left.`}{' '}
      <Link to="/billing" className="font-medium underline">
        {expired ? 'Upgrade now' : 'See plans'}
      </Link>
    </div>
  );
}
